<template>
  <div class="storage-register-list">
    <div class="storage-register-list-search">
      <div class="screen">
        <el-select class="white w200" clearable filterable v-model="screen.projectId" placeholder="请选择项目">
          <el-option
            v-for="item in projectList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-input class="white w240" v-model="screen.inboundOrderNo" placeholder="请输入进仓编号"></el-input>
        <el-date-picker
          class="w240"
          v-model="screen.date"
          type="daterange"
          placeholder="请选择日期"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
        <el-button class="btn-blue" @click="onScreen">搜索</el-button>
      </div>
      <div class="operation-btn">
        <el-button class="btn-white" @click="toStorageRegister"
          >前往登记</el-button
        >
      </div>
    </div>

    <DropTable
      ref="table"
      :columns="tableTitle"
      :data="tableData"
      tableKey="storageRegisterList"
      border
    >
      <template slot="registerMonthNums" slot-scope="scope">
        <span>{{ scope.row.registerMonthNums }}</span>
        <el-tooltip class="item" effect="dark" placement="top" ref="returnObj">
          <div v-html="scope.row.content" slot="content"></div>
          <img class="question-mark" src="~assets/images/charge-record/question-mark.png">
        </el-tooltip>
      </template>
      <template slot="statusVal" slot-scope="scope">
        <span :class="`status${scope.row.status}`">{{ scope.row.statusVal }}</span>
      </template>
      <template slot="action" slot-scope="scope">
        <el-button class="btn-text" type="text" @click="lookDetails(scope.row.id)">详情</el-button>
      </template>
    </DropTable>

    <div class="footer">
      <pagination-tpl :total="total" :currentPage="currentPage" :pageSize="pageSize"
        :layout="layout"
        @queryChange="queryChange"
        @onSizeChange="onSizeChange"
      ></pagination-tpl>
    </div>
  </div>
</template>

<script>
import DropTable from "components/base/DropTable.vue";
import StorageRegister from "models/storage-register";
import PaginationTpl from "components/base/PaginationTpl";
import EnterExitWarehouseProjectMixins from 'common/mixins/enter-exit-warehouse-project'
import { modifyNetTitle } from "common/js/util";
export default {
  mixins: [EnterExitWarehouseProjectMixins],
  data() {
    return {
      screen: {
        projectId: "",
        inboundOrderNo: "",
        date: ""
      },
      tableData: [],
      tableTitle: [
        { checked: true, prop: 'inboundOrderNo', label: '进出单号', "min-width": 140},
        { checked: true, prop: 'projectName', label: '项目名称', "min-width": 170},
        { checked: true, prop: 'inboundDate', label: '进仓日期', "width": 120},
        { checked: true, prop: 'registerMonthNums', label: '已登记月数', "width": 110, slotName: "registerMonthNums" },
        { checked: true, prop: 'statusVal', label: '登记状态', "width": 100, slotName: "statusVal"},
        { checked: true, prop: 'registrationCharge', label: '已登记金额', "width": 110},
        { checked: true, prop: 'outStockCompleteVal', label: '是否完成出库', "width": 120},
        { 
          checked: true, 
          label: "操作", 
          prop: "action", 
          fixed: "right", 
          "width": "90",
          slotName: "action", // 自定义单元格插槽
        }
      ],
      total: 0,
      currentPage: 1,
      pageSize: 20,
      layout: 'jumper, prev, pager, next, sizes'
    };
  },
  components: {
    DropTable,
    PaginationTpl
  },
  created() {
    modifyNetTitle('存储登记列表')
    this.initStorageRegisterList();
    this.initEnterExitWarehouseProjectData();
  },
  methods: {
    /** 
     * @desc 获取仓储登记列表列表
    */
    initStorageRegisterList() {
      let pageNo = this.currentPage;
      let pageSize = this.pageSize;
      let projectId = this.screen.projectId;
      let inboundOrderNo = this.screen.inboundOrderNo;
      let inboundStartDate = this.screen.date?this.screen.date[0]:''
      let inboundEndDate = this.screen.date?this.screen.date[1]:''
      let data = {
        pageNo,
        pageSize,
        projectId,
        inboundOrderNo,
        inboundStartDate,
        inboundEndDate
      }
      StorageRegister.getStorageRegisterList(data).then(res => {
        if (res.success) {
          let tableData = [];
          this.pageSize = res.result.size;
          this.total = res.result.total;
          res.result.records.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.inboundOrderNo = value.inboundOrderNo;
            obj.projectName = value.projectName;
            obj.inboundDate = value.inboundDate;
            let registerMonthObj = this.registerMonthNums(value.inboundDate, value.recentCalculateDate)
            obj.registerMonthNums = registerMonthObj.nums;
            obj.content = registerMonthObj.content
            obj.status = value.registrationStatus?1:0;
            obj.statusVal = value.registrationStatus ?'已登记':'未登记';
            obj.registrationCharge = value.registrationCharge;
            obj.outStockComplete = value.outStockComplete;
            obj.outStockCompleteVal = value.outStockComplete?'已出库':'未完全出库';
            tableData.push(obj);
          });
          this.tableData = tableData;
        } else {
          this.$message.error(res.message);
        }
      });
    },

    /** 
     * @desc 已登记月数
    */
    registerMonthNums(inboundDate, recentCalculateDate) {
      let startDate = new Date(inboundDate)
      let inboundYear = startDate.getFullYear()
      let inboundMonth = startDate.getMonth() + 1

      let entDate = new Date(recentCalculateDate)
      let recentCalculateYear = entDate.getFullYear()
      let recentCalculateMonth = entDate.getMonth() + 1
      let nums = 0
      let content = `<p style="margin-bottom: 2px;font-size: 12px;line-height: 16px;">已登记月份</p>`
      let yearMonthStr = ''
      for (let i = inboundYear; i < recentCalculateYear+1; i++) {
        let yearStr = `${i}：`
        for (let j = 1; j < 13; j++ ) {
          let monthStr = ''
          let jStr = j < 10?`0${j}`:j
          if (inboundYear !== recentCalculateYear) {
            // 不同年
            if (i === inboundYear) {
              if (j > inboundMonth || j === inboundMonth) {
                monthStr += `/${jStr}`
                nums++
              }
              if (j === inboundMonth) {
                monthStr = monthStr.substr(1)
              }
            }
            if (i === recentCalculateYear) {
              if (j < recentCalculateMonth || j === recentCalculateMonth) {
                monthStr += `/${jStr}`
                nums++
              }
            }
            if (i > inboundYear && i < recentCalculateYear) {
              monthStr += `/${jStr}`
              nums++
            }
          } else {
            // 同一年
            if ((j > inboundMonth || j === inboundMonth ) && (j <recentCalculateMonth || j === recentCalculateMonth)) {
              monthStr += `/${jStr}`
              nums++
            }
            if (j === inboundMonth) {
              monthStr = monthStr.substr(1)
            }
          }
          if (j === 1) {
            monthStr = monthStr.substr(1)
          }
          yearStr += monthStr
        }
        yearMonthStr += `<p style="margin-bottom: 2px;font-size: 12px;line-height: 16px;">${yearStr}</p>`
      }
      return {
        nums,
        content: content += yearMonthStr
      }
    },

    onScreen() {
      this.currentPage = 1;
      this.initStorageRegisterList();
    },

    /** 
     * @desc 前往登记
    */
    toStorageRegister() {
      this.$router.push({
        path: '/service/storage-register-index/storage-register-details-index/storage-register',
        query: {
        }
      })
    },

    //查看详情
    lookDetails(id) {
      this.$router.push({
        path: '/service/storage-register-index/storage-register-details-index/storage-register-details',
        query: {
          id
        }
      })
    },

    //翻页
    queryChange(data) {
      this.currentPage = data.currentPage;
      this.initStorageRegisterList();
    },
    onSizeChange(data) {
      this.pageSize = data.pageSize;
      this.initStorageRegisterList();
    }
  }
};
</script>
<style lang="scss">
.storage-register-list {
  flex: 1;
  background: #fff;
  border-radius: 4px;
  padding: 16px;
  box-sizing: border-box;
  .storage-register-list-search {
    display: flex;
    justify-content: space-between;
    margin-bottom: 16px;
    .screen {
      display: flex;
      .w200 {
        width: 200px;
        margin-right: 16px;
      }
      .w240 {
        width: 240px;
        margin-right: 16px;
      }
    }
    .operation-btn {
      display: flex;
    }
  }
  .footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 0 16px;
  }
  .table {
    .btn-text.is-disabled {
      color: #CCCCCC;
    }
    .question-mark {
      width: 14px;
      height: 14px;
      margin-left: 4px;
    }
    .status0,
    .status1 {
      width: 48px;
      height: 24px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-family: 'PingFang SC-Regular';
      font-weight: 400;
      font-size: 12px;
      border-radius: 4px 4px 4px 4px;
    }
    .status0 {
      background: #F5F5F5;
      color: #666666;
    }
    .status1 {
      background: #E4F5EF;
      color: #22A979;
    }
    .el-table .el-table__body-wrapper .el-table__body tr td .cell {
      display: flex;
      align-items: center;
    }
  }
}
</style>
